export default __webpack_public_path__ + "static/media/673.837cfdf6.gif";